export default __webpack_public_path__ + "static/media/rusSauna.7fb05dc0.png";